import { defineMessages } from 'react-intl'

export default defineMessages({
  errorTitle: {
    id: 'pages.Error.errorTitle',
    defaultMessage: 'An error has occurred',
  },
  errorMessage: {
    id: 'pages.Error.errorMessage',
    defaultMessage: 'We apologize for the inconvenience',
  },
  notFoundTitle: {
    id: 'pages.Error.notFoundTitle',
    defaultMessage: 'Error 404',
  },
  notFoundMessage: {
    id: 'pages.Error.notFoundMessage',
    defaultMessage: 'We could not find the page on our servers',
  },
  resourceNotFoundTitle: {
    id: 'pages.Error.resourceNotFoundTitle',
    defaultMessage: 'Error 404',
  },
  resourceNotFoundMessage: {
    id: 'pages.Error.resourceNotFoundMessage',
    defaultMessage: 'We could not find the resource',
  },
  disabledUserTitle: {
    id: 'pages.Error.disableUserTitle',
    defaultMessage: 'Permission denied',
  },
  disabledUserMessage: {
    id: 'pages.Error.disableUserMessage',
    defaultMessage: 'You do not have the right to perform this action, please switch organization view',
  },
})
